import { useaxios } from "../../../../utils/useaxios";
export default (company_income_purpose, company_income_amount, company_income_invoiceno, company_income_note, company_income_date, company_income_id) => setloading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    setloading(true);
    useaxios('company_income/update.php', { company_income_purpose, company_income_amount, company_income_invoiceno, company_income_note, company_income_date, company_income_id }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
        } else {
            // clear();
        }
        setloading(false);
    });
}